import VueFormProgress from '@assets/js/vue-components/VueFormProgress.vue'
import VueAddressAutocomplete from '@views/elements/address-autocomplete/VueAddressAutocomplete.vue';
import FormHelpers from '@assets/js/form-helpers.js';
import PersonalDataFormHelpers from '@assets/js/form-validation-personaldata.js';
import PasswordValidationMixin from '@assets/js/vue-components/PasswordValidationMixin.js';
import InvalidCharacterValidationMixin from '@assets/js/vue-components/InvalidCharactersValidationMixin.js';
import { smoothScrollIntoViewIfNeeded, smoothScrollIntoView } from '@assets/js/smooth-scroll-into-view.js';
import { useModal } from '@assets/js/modals/useModal.js';
import ModalManager from '@assets/js/modals/ModalManager.vue';

import dayjs from 'dayjs';

// Some internal video state (for the English video)
let vimeoPlayer = null;
let videoLastSeconds = 0;
let videoPlayedSecs = 0;
let videoStartedEventTriggered = false;

export const app = {
  'name': 'ApplicationFormApp',

  components: {
    VueFormProgress,
    VueAddressAutocomplete,
    ModalManager,
  },

  mixins: [
    PasswordValidationMixin,
    InvalidCharacterValidationMixin
  ],

  props: {
    formName: {
      type: String,
      required: true
    },
    formSource: {
      type: String,
      required: false
    },
    formLang: {
      type: String,
      required: false
    },
    mode: {
      type: String,
      required: false
    },
    disyDown: {
      type: Boolean,
      required: false
    },
    disylessData: {
      type: Object,
      required: false
    },
    routes: {
      type: Object,
      required: false
    }
  },

  data() {
    return {
      // TODO: Remove this again
      debug: false, // true && window.location.hostname == 'nyblivomdeler.test',

      // Step state
      currentStep: 1,
      totalSteps: 4,
      validStep: false, // Indicates whether all fields on the current step has validated
      stepValidationText: null, // Text to show when step is invalid due to specific conditions
      submitError: null, // Text to show when the application failed to submit
      showDisyDownError: false, // Is use to display a message if DiSy is down when the application is submitted

      // Other state
      isSubmitting: false,
      hasSubmitted: false,
      activeFields: null,
      invalidFields: [],
      passwordVisible: false,
      repeatPasswordVisible: false,
      isValidAddress: false,
      hasVideoSection: false,
      videoRequired: false,
      videoWatched: false,
      consentExpanded: false,

      // Additional properties needed for validation
      emailUnique: null, // Email uniqueness check result
      hasCheckedEmail: null,

      // State related to the form fields
      showEnglishMsg: false,
      showSwedishMsg: false,
      showDanishMsg: false,
      showEmailInvalidText: false,
      showEmailValidationText: false,
      showMobileValidationText: false,
      showPhoneValidationText: false,
      showAnvistPhoneValidationText: false,
      showManualAddress: false,
      addressAutocomplete: null,
      invalidCharsInEmail: false,
      showZipcodeInvalidText: false,

      // When manually importing disyless applications
      manualAddressString: false,

      // Used to override the formname if the user comes from "Find routes" and has previously visited the Nordjylland landing page
      overriddenFormName: null,

      // Data for the application
      addressAutocomplete: null,
      application: {
        language: null,
        gender: null,
        bday_day: '',
        bday_month: '',
        bday_year: '',
        workinghours: null,
        contacttime: null,
        firstname: null,
        lastname: null,
        email: null,
        repeat_email: null,
        password: null,
        repeat_password: null,
        mobile_number: null,
        phone_number: null,
        transport: null,
        reference: '',
        anvist: null,
        anvist_name: null,
        anvist_phone: null,
        conditions_accepted: false,
      },

      // For disyless applications
      disyless: {
        street: null,
        street_number: null,
        street_letter: null,
        street_floor: null,
        street_side: null,
        zipcode: null,
        city: null,
      },

      // Nordjyske - do you have previous experience as a distributor?
      hasExperience: null,

      // State after submitting the application
      salaryno: null,
      logged_in: false,
    }
  },

  computed: {
    isValidDate() {
      return FormHelpers.isValidDate(this.application.bday_day, this.application.bday_month, this.application.bday_year);
    },
    isUnderThirteen() {
      return FormHelpers.isUnderThirteen(this.application.bday_day, this.application.bday_month, this.application.bday_year);
    },
    isUnderEighteen() {
      return FormHelpers.isUnderEighteen(this.application.bday_day, this.application.bday_month, this.application.bday_year);
    },
    isOverEighteen() {
      return FormHelpers.isOverEighteen(this.application.bday_day, this.application.bday_month, this.application.bday_year);
    },
    u13birthdayStamp() {
      // This appends a timestamp with the selected birthday to the link to the U13 form so that the form can be pre-filled with the birthday
      if (this.isUnderThirteen) {
        const bday = dayjs(this.application.bday_day+'-'+this.application.bday_month+'-'+this.application.bday_year,'D-M-YYYY');
        const timestamp = bday.unix();
        return '?ts=' + timestamp;
      }
      return '';
    },
    showExperienceQuestion() {
      // We no longer show the experience question
      return false;

      /*
      const nordjyskeZipcodes = [7741, 7742, 7900, 7950, 7960, 7970, 7980, 7990, 9000, 9200, 9210, 9220, 9230, 9240, 9260, 9270, 9280, 9293, 9300, 9310, 9320, 9330, 9340, 9352, 9362, 9370, 9380, 9381, 9382, 9400, 9430, 9440, 9460, 9480, 9490, 9492, 9493, 9500, 9510, 9520, 9530, 9541, 9560, 9574, 9575, 9600, 9610, 9640, 9670, 9681, 9690, 9700, 9740, 9750, 9760, 9800, 9830, 9850, 9870, 9881, 9900, 9940, 9970, 9981, 9982, 9990];

      if (window.selskabsnr != 1) {
        return false;
      }

      var zipcode = null;
      if (this.disyDown) {
        zipcode = this.disyless?.zipcode;
      } else {
        if (this.addressAutocomplete) {
          const selskabsnr = this.addressAutocomplete?.addressData?.selskabsnr;
          if (selskabsnr && selskabsnr == 51) {
            // Always show the question when the selskabsnr is Nordjyske
            return true;
          } else {
            zipcode = this.addressAutocomplete?.addressData?.zipcode;
          }
        }
      }

      if (zipcode && nordjyskeZipcodes.includes(parseInt(zipcode))) {
        return true;
      }

      return false;
      */
    },
    showValidationText() {
      return this.stepValidationText || (this.invalidFields && this.invalidFields.length);
    }
  },

  watch: {
    currentStep: {
      immediate: true,
      handler(newVal) {
        if (this.$el) {
          const root = this.$el.closest('.application-form') || this.$el.parentElement;
          if (root) {
            root.classList.toggle('last-step', newVal == 4);
          }
        }
      }
    }
  },

  mounted() {
    this.modal = useModal();

    // For English applications, we required them to watch a video
    // Unless you provide a ?skipvideo query string parameter
    this.hasVideoSection = this.$el.querySelector('.application-en-video') != null;
    this.videoRequired = (window.pagelang != 'da') && location.search.indexOf('skipvideo') == -1;

    if (this.hasVideoSection) {
      this.initVideoEvents();
    }

    // Make the "Apply" button in the header (and mobile menu) scroll down to the form
    const applyBtns = document.querySelectorAll('.js--apply-btn');
    applyBtns.forEach(applyButton => {
      // Change the apply url to the current page, using the hash
      const moduleElem = this.$el.closest('.application-form');
      const hash = moduleElem.id;
      let applyUrl = window.location.href.split('#')[0];
      if (hash) {
        applyUrl += '#' + hash;
        applyButton.href = applyUrl;
      }

      applyButton.addEventListener('click', (e) => {
        e.preventDefault();
        // Close mobile menu if it is open
        document.dispatchEvent(new CustomEvent('closeMobileMenu'));
        smoothScrollIntoView(this.$el);
        // Also update the URL in the browser
        window.history.pushState({}, '', applyUrl);
      });
    });

    // Add a flag in sessionstorage if the user visits the Nordjylland landing page AND has an utm parameter in the URL
    if (this.formName == 'nordjylland' || this.formName == 'nordjylland_en') {
      if (window.location.search.includes('utm_source')) {
        sessionStorage.setItem('nordjylland_lp', 'true');
      }
    }

    // Check the Nordjylland landing page flag to decide if we should override the form name
    const nordjyllandLp = sessionStorage.getItem('nordjylland_lp');
    if (nordjyllandLp) {
      // Override the "Find routes" form names to use the Nordjylland form names
      if (this.formName == 'findrute_v2') {
        this.overriddenFormName = 'nordjylland_rute';
      }
      if (this.formName == 'findrute_en') {
        this.overriddenFormName = 'nordjylland_rute_en';
      }

      // Override the normal application form names to use the Nordjylland form names
      if (this.formName == 'v2') {
        this.overriddenFormName = 'nordjylland';
      }
      if (this.formName == 'v2-en') {
        this.overriddenFormName = 'nordjylland_en';
      }
    }

    // Add 'onchange' handlers to validate fields and mark the current step as valid/invalid
    // Also set up 'keyup' handlers to validate fields while typing
    FormHelpers.initFormEvents(this.$el, {
      onFieldChanged: this.onFieldChanged,
      onChange: this.onFieldUpdated
    });

    // Populate the state with disyless data if present
    if (this.disylessData) {
      // Copy all the relevant properties
      const fields = ['language', 'gender', 'bday_day', 'bday_month', 'bday_year', 'workinghours', 'contacttime', 'firstname', 'lastname', 'email', 'mobile_number', 'phone_number', 'transport', 'reference', 'anvist', 'anvist_name', 'anvist_phone', 'conditions_accepted'];
      fields.forEach(field => {
        this.application[field] = this.disylessData[field];
      });
      this.application.repeat_email = this.disylessData.email;
      if (this.disylessData.anvist_name || this.disylessData.anvist_phone) {
        this.application.anvist = 1;
      } else {
        this.application.anvist = 0;
      }

      if (this.disylessData.has_experience) {
        // Nordjyske - the applicant already has experience with the job
        this.hasExperience = true;
      }

      // Don't require watching the video for disyless applications with English selected as language
      this.videoRequired = false;

      // Remove the 'untouched' class from all fields and add "with-value"
      const inputs = this.$el.querySelectorAll('.untouched');
      inputs.forEach(input => {
        input.classList.remove('untouched');
        input.classList.add('with-value');
      });

      this.manualAddressString = this.getAddressString();
      this.validateStep();
    }

    // Update the elements list
    this.updateElementsList();
  },

  methods: {

    // FIELD HELPERS AND VALIDATION

    getRepeatPasswordField() {
      return this.$refs.repeatPassword;
    },

    updateElementsList() {
      const stepContainer = this.$el.querySelector(`[step="${this.currentStep}"]`);
      if (!stepContainer) {
        this.activeFields = null;
        return;
      }

      let elems = stepContainer.querySelectorAll('input:not([type="radio"]), select, .radio-group');
      if (elems.length == 0) {
        this.activeFields = null;
        return;
      }

      if (this.debug) {
        // Validate fields across all steps when debugging
        elems = this.$el.querySelectorAll('[step] input:not([type="radio"]), select, .radio-group');
      }

      this.activeFields = Array.from(elems);
    },

    onLanguageClick(langcode) {
      this.showEnglishMsg = (window.pagelang != 'en' && langcode == 'en');
      this.showSwedishMsg = (window.pagelang != 'sv' && langcode == 'sv');
      this.showDanishMsg = (window.pagelang != 'da' && langcode == 'da');

      // If the user selected English on the Danish application form, make the video required
      if ((window.pagelang == 'da' || window.pagelang == 'sv') && this.hasVideoSection && location.search.indexOf('skipvideo') == -1) {
        this.videoRequired = this.showEnglishMsg;
      }
    },

    togglePasswordVisible() {
      this.passwordVisible = !this.passwordVisible;
    },

    toggleRepeatPasswordVisible() {
      this.repeatPasswordVisible = !this.repeatPasswordVisible;
    },

    onEmailChanged(e) {
      // This function is called on keyup for the email fields
      var field = e.currentTarget;

      // No revalidation if the field is still pristine
      if (field.classList.contains('untouched')) {
        return;
      }

      if (field.name == 'email' && this.$refs.repeatEmail.value) {
        // Also revalidate the repeat email field (in case the user corrects the value in the original email field)
        this.onFieldUpdated(this.$refs.repeatEmail, true)
      }
    },

    onFieldChanged(field) {
      PersonalDataFormHelpers.onFieldChanged(field);

      this.onFieldUpdated(field, true, true);
    },

    onFieldUpdated(field, forceValidation, checkPreviousFields) {
      // Check invalid characters before checking for other types of errors
      if (!this.validateInvalidCharacters(field)) {
        return false;
      }

      PersonalDataFormHelpers.onFieldUpdated(field, this.validateField, forceValidation);

      this.validateStep(checkPreviousFields);
    },

    async checkEmailAddress() {
      if (!this.application.email) {
        // No email typed yet
        return;
      }

      if (this.application.email && this.hasCheckedEmail && this.hasCheckedEmail == this.application.email) {
        // No need to check the email again
        return;
      }

      // No need to check invalid email addresses
      if (!FormHelpers.isEmailValid(this.application.email)) {
        return;
      }

      if (!this.modal) {
        // If modal is not available, skip the check
        console.log('Modal not available, skipping email check');
        return;
      }

      // TODO: Perform the email check
      const pagelang = window.pagelang;
      const selected_lang = this.application.language === 1 ? 'en' : 'da';

      const args = {
        action: 'check_email_uniqueness',
        email: this.application.email,
        language: pagelang,
        selected_lang: selected_lang
      };

      try {
        const data = await FormHelpers.postFormData(args, {
          suppressServerErrors: true
        });
        this.emailUnique = data;

        // Handle the response from the email uniqueness check
        if (data && data.success === false && data.message) {
          // Show modal if email is not unique
          let btnText;
          if (data.block_application) {
            btnText = __('Okay');
          } else {
            btnText = __('Fortsæt alligevel');
          }

          const msg = data.long_message || data.message;

          if (this.modal) {
            this.modal.alert({
              message: msg,
              confirmText: btnText,
              closeOnEsc: false,
            });
          }
        }
      } catch (error) {
        console.error('Error checking email:', error);
      }

      // Validate the step after email check
      this.validateStep();

      this.hasCheckedEmail = this.application.email;
    },

    validateField(field) {
      if (field.required && !field.value) {
        return false;
      }

      var isValid = true;

      if (field.type == 'email') {
        isValid = FormHelpers.isEmailValid(field.value);
        if (field.name == 'email') {
          this.showEmailInvalidText = !isValid;
        }
        if (field.name == 'repeat_email' && this.$refs.email) {
          // Important: We need to check the value of the email field instead of this.email (because angular doesn't set the scope if the value is not a valid email address)
          if (field.value != this.$refs.email.value) {
            isValid = false;
            this.showEmailValidationText = true;
          } else {
            this.showEmailValidationText = false;
            if (field.value) {
              field.classList.add('with-value')
              field.classList.remove('invalid-value');
            }
          }
        }
      }

      if (field.type == 'tel') {
        if (field.value) {
          isValid = FormHelpers.isPhoneNumberValid(field.value);
        }
        if (field.name == 'mobile_number') {
          this.showMobileValidationText = !isValid;
        }
        if (field.name == 'phone_number') {
          this.showPhoneValidationText = !isValid;
        }
        if (field.name == 'anvist_phone') {
          this.showAnvistPhoneValidationText = !isValid;
        }
      }

      // We cannot rely on the field type for password fields because it changes to 'text' when you click the eye icon
      if (field.name == 'password') {
        isValid = this.isPasswordValid(field.value);
      }
      if (field.name == 'repeat_password') {
        if (field.value != this.application.password) {
          isValid = false;
          this.showPasswordValidationText = true;
        } else {
          this.showPasswordValidationText = false;
          if (field.value) {
            field.classList.add('with-value')
            field.classList.remove('invalid-value');
          }
        }
      }

      // Validate zip code
      var validationType = field.getAttribute('validate-field');
      if (validationType == 'zipcode') {
        isValid = FormHelpers.isPZipcodeValid(field.value);
        this.showZipcodeInvalidText = !isValid;
      }

      return isValid;
    },

    handleAddressSelect(item) {
      this.addressAutocomplete = item;
      this.isValidAddress = true;
      // Validate the step, including any previous fields, when an address is selected
      this.validateStep(true);
    },

    handleAddressError(item) {
      this.addressAutocomplete = item;
      this.isValidAddress = false;
      // If an address error occurs, we only validate the current field, not previous fields in the form
      this.validateStep(false);
    },

    blurAddressField(item) {
      // Validate the step, including any previous fields if no valid address has been selected
      return;
      if (!this.isValidAddress) {
        this.validateStep(true);
      }
    },

    // MANUAL IMPORT OF DISYLESS APPLICATIONS

    getAddressString() {
      // Define address parts array
      var addressParts = [
        this.disylessData.street,
        this.disylessData.street_number + (this.disylessData.street_letter || ''),
        this.disylessData.street_floor,
        this.disylessData.street_side,
        this.disylessData.zipcode,
        this.disylessData.city
      ];

      // Filter out empty or undefined values
      addressParts = addressParts.filter(function(part) {
        return part;
      });

      // Join the addressParts with a space
      return addressParts.join(' ');
    },

    searchManualAddress(e) {
      e.preventDefault();

      if (this.$refs.addressAutocompleteComponent) {
        const input = this.$refs.addressAutocompleteComponent.autocompleteRef.$refs.input;
        input.value = this.manualAddressString;
        // Trigger an input event
        input.dispatchEvent(new Event('input', { bubbles: true }))
        input.focus();
      }
    },

    // ENGLISH VIDEO HELPERS

    initVideoEvents() {
      document.addEventListener('vimeoVideoLoaded', (e) => {
        const newPlayer = e.detail ? e.detail.player : null;
        if (newPlayer && vimeoPlayer != newPlayer) {
          // Reset the video state
          this.videoWatched = false;
          videoLastSeconds = 0;
          videoPlayedSecs = 0;

          // Add the player events
          newPlayer.on('play', this.resetVideoPlayhead)
          newPlayer.on('play', this.triggerVideoPlayEvent)
          newPlayer.on('seeked', this.resetVideoPlayhead)
          newPlayer.on('timeupdate', this.updateSecondsPlayed)

          // Remove the old player events
          if (vimeoPlayer) {
            vimeoPlayer.off('play', this.resetVideoPlayhead)
            vimeoPlayer.off('play', this.triggerVideoPlayEvent)
            vimeoPlayer.off('seeked', this.resetVideoPlayhead)
            vimeoPlayer.off('timeupdate', this.updateSecondsPlayed)
          }

          vimeoPlayer = newPlayer;
        }
      })

      // Listen for the overrideVimeoEndScreen event
      document.addEventListener('overrideVimeoEndScreen', this.vimeoPlayerEndScreenCallback)
    },

    resetVideoPlayhead(data) {
      // The user pressed played or seeeked to a new position in the video
      videoLastSeconds = data.seconds;
    },

    updateSecondsPlayed(data) {
      const seconds = data.seconds;
      if (seconds > videoLastSeconds && !this.videoWatched) {
        var diff = seconds - videoLastSeconds;
        // The diff should normally be around 250 ms, so if it's larger than 0.4 seconds then we assume that the user seeked in the video
        if (diff < 0.4) {
          videoPlayedSecs += diff;
          if (videoPlayedSecs > data.duration * 0.9) {
            this.videoWatched = true;
            this.validateStep(true);
            // Trigger an Analytics event
            this.triggerVideoCompletedEvent();
          }
        }
        videoLastSeconds = seconds
      }
    },

    triggerVideoPlayEvent() {
      if (!videoStartedEventTriggered) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event' : 'applicationVideoStarted',
        });
      }
    },

    triggerVideoCompletedEvent() {
      if (!videoStartedEventTriggered) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event' : 'applicationVideoCompleted',
        });
      }
    },

    vimeoPlayerEndScreenCallback(e) {
      const overrides = e.detail;
      if (this.videoRequired && !this.videoWatched) {
        // Show a message on the video end screen
        overrides.msg = "It looks like you've skipped over parts of the video. Please watch the entire video.";
      } else {
        // On the application form, close the video when it ends
        overrides.closeOverlay = true;
      }
    },

    // STEP VALIDATION

    validateStep(checkPreviousFields) {
      const isValid = this.isStepValid(checkPreviousFields);
      this.validStep = isValid;
      return isValid;
    },

    isStepValid(checkPreviousFields) {
      this.stepValidationText = null;

      // Don't enable the next button if under 13
      if (this.isUnderThirteen && this.currentStep >= 2) {
        this.invalidFields = null;
        return false;
      }

      // Set the stepValidationText if there is an application with the same email and the block_application flag is set
      if (this.emailUnique && this.emailUnique.success === false && this.currentStep > 1) {
        if (this.emailUnique.block_application) {
          this.stepValidationText = this.emailUnique.message;
          this.invalidFields = null;
          return false;
        }
      }

      let isValid = true;
      // This flag is set to true when we find the first field that has a value
      let fieldWithValueFound = false;
      let invalidFields = [];

      // Don't enable the next button if a valid autocomplete address has not been selected
      if (this.currentStep == 2 && !this.disyDown && !this.showManualAddress && !this.addressAutocomplete) {
        isValid = false;
      }

      // Variables used for conditionally validating fields
      const isOverEighteen = this.isOverEighteen;

      // Add a message if the selected birthdate is an invalid date
      const isInvalidDate = !this.isValidDate;
      if (isInvalidDate) {
        isValid = false;
        invalidFields.push(__('Fødselsdatoen er ikke en gyldig dato'));
      }

      // Check all the required fields on the current step
      // We iterate over the fields in reverse order so that we can more intelligently highlight missing fields
      if (this.activeFields) {
        for (let i = this.activeFields.length - 1; i >= 0; i--) {
          const field = this.activeFields[i];
          let currentFieldIsInvalid = false;

          // Conditional validation of fields
          const conditions = field.getAttribute('validate-if');
          if (conditions) {
            if (conditions == 'O18' && !this.isOverEighteen) {
              continue;
            }
          }

          if (field.required) {
            if (field.type == 'checkbox') {
              if (!field.checked) {
                currentFieldIsInvalid = true;
                if (fieldWithValueFound) {
                  // Indicate to the user that this field is not filled out
                  FormHelpers.showFieldError(field);
                }
              } else {
                fieldWithValueFound = true;
                // Hide any previous errors
                FormHelpers.clearFieldError(field);
              }
            }

            if (field.type != 'checkbox' && field.type != 'radio') {
              if (!field.value || field.classList.contains('invalid-value')) {
                currentFieldIsInvalid = true;
                if (checkPreviousFields && fieldWithValueFound) {
                  // Indicate to the user that this field is not filled out
                  field.classList.add('invalid-value');
                }
              }
              if (field.value) {
                // Don't mark the birthday fields as having a value until all 3 have been filled
                if (field.name == 'bday_day' || field.name == 'bday_month' || field.name == 'bday_year') {
                  if (this.application.bday_day && this.application.bday_month && this.application.bday_year) {
                    fieldWithValueFound = true;
                  }
                } else {
                  fieldWithValueFound = true;
                }
              }
            }

            // Mark the individual date fields as invalid if the user has selected an invalid date
            if (field.name == 'bday_day' || field.name == 'bday_month' || field.name == 'bday_year') {
              if (isInvalidDate) {
                isValid = false;
                if (checkPreviousFields && fieldWithValueFound) {
                  // Indicate to the user that this field is not filled out
                  field.classList.add('invalid-value');
                }
              } else if (field.value) {
                field.classList.remove('invalid-value');
              }
            } else if (field.tagName == 'SELECT') {
              // Handle otherselect fields - show or hide error message
              if (field.value) {
                FormHelpers.clearFieldError(field);
              } else {
                if (checkPreviousFields && fieldWithValueFound) {
                  FormHelpers.showFieldError(field);
                }
              }
            }
          }

          // Check that radio-group have a value
          if (field.classList.contains('radio-group')) {
            const groupElem = field
            if (groupElem) {
              if (groupElem.querySelector('input:checked, select.with-value')) {
                fieldWithValueFound = true;
                // Hide any previous errors
                FormHelpers.clearFieldError(field);
              } else {
                isValid = false;
                currentFieldIsInvalid = true;
                if (checkPreviousFields && fieldWithValueFound) {
                  // Indicate to the user that this field is not filled out
                  FormHelpers.showFieldError(field);
                }
              }
            }
          }

          // Check that the address field is valid
          if (field.name == 'address-search') {
            if (!this.disyDown) {
              if (!this.isValidAddress) {
                currentFieldIsInvalid = true;
                if (this.$refs.addressAutocompleteComponent) {
                  const input = this.$refs.addressAutocompleteComponent.autocompleteRef.$refs.input;
                  const searchStr = input.value;
                  if (searchStr) {
                    fieldWithValueFound = true;
                  }
                }
              }
            }
          }

          if (currentFieldIsInvalid) {
            isValid = false;

            // Highlight that this field has not been filled yet?
            if (checkPreviousFields && fieldWithValueFound) {
              // The placeholder value is used for the address autocomplete field
              let field_label = field.dataset.errorname;
              if (!field_label) {
                // Take the text from the label
                const label_element = field.parentElement.querySelector('.inline-label');
                if (label_element) {
                  field_label = label_element.textContent;
                }
              }
              if (!field_label && field.placeholder) {
                field_label = field.placeholder;
              }
              if (field_label) {
                invalidFields.push(field_label);
              }
            }
          }
        }
      }

      // On the English application, check that the video has been watched
      if (this.videoRequired && !this.videoWatched) {
        let showVideoValidationError = true;

        // Only show the validation error on the Danish form if the gender field has been filled out
        if ((window.pagelang == 'da' || window.pagelang == 'sv') && this.$el.querySelector('.radio-group input[name="gender"]:checked') == null) {
          // The gender field has not been checked yet
          showVideoValidationError = false;
        }
        if (showVideoValidationError) {
          isValid = false;
          invalidFields.push(__('Se videoen om jobbet'));
        }
      }

      if (checkPreviousFields) {
        this.invalidFields = invalidFields.reverse();
      }

      return isValid;
    },

    // STEP NAVIGATION / TOGGLING

    nextStep() {
      if (this.currentStep < this.totalSteps && this.validateStep()) {
        this.switchToStep(this.currentStep + 1)
      }
    },

    prevStep() {
      if (this.currentStep > 1) {
        this.switchToStep(this.currentStep - 1)
        // Clear the submitError if one is present
        this.submitError = null;
      }
    },

    switchToStep(step) {
      const previousStep = this.currentStep;
      if (step && step <= this.totalSteps && step != this.currentStep) {
        this.currentStep = step
        this.updateElementsList();

        // Send GTM event
        if (this.mode != 'manualimport') {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event' : 'switchedStep',
            'step' : step,
          });
        }

        if (previousStep < step) {
          this.validateStep();

          // smooth scroll to top of new "page"
          smoothScrollIntoViewIfNeeded(this.$el);
        } else {
          this.validStep = true;
        }
      }
    },

    // SUBMIT APPLICATION

    async submitApplication(e) {
      e.preventDefault();
      if (!this.validateStep()) {
        return;
      }

      if (this.isSubmitting) {
        return;
      }

      let args = {
        action:'disy_submit_application',
        is_ajax: true,
        mode: this.mode,
        form: this.overriddenFormName ? this.overriddenFormName : this.formName,
        form_source: this.formSource,
        lang: this.formLang
      };

      // Merge the application fields
      args = Object.assign(args, this.application);

      // Merge the selected routes
      if (this.routes) {
        // TODO: Remove this code when we permanently switch to the new API (once we set isFeatureEnabled to true for 'findroutes')
        if (this.routes.routes_zipcode) {
          // The legacy API needs all the routes data
          args = Object.assign(args, this.routes);
        } else {
          // The new API only need the route IDs
          args.routes = this.routes;
        }
      }

      // For U18 applications, make sure we don't send any data for the O18 fields
      // These fields can contain a value if the user had first selected an incorrect year and filled out the fields
      if (this.isUnderEighteen) {
        args.workinghours = null;
        args.contacttime = null;
        args.transport = null;
        args.over_eighteen = false;
      } else {
        args.over_eighteen = true;
      }

      const args_disy_down = {
        ...this.disyless,
      };

      const args_disy_not_down = {
        address_value: this.addressAutocomplete?.addressData?.value,
        address_streetid: this.addressAutocomplete?.addressData?.vejnr,
        address_kommuneid: this.addressAutocomplete?.addressData?.kommuneID,
        address_object: this.addressAutocomplete?.addressData,
      };

      if (this.disyDown) {
        args = Object.assign(args, args_disy_down);
      } else {
        args = Object.assign(args, args_disy_not_down);
      }

      if (this.showExperienceQuestion && this.hasExperience) {
        args.has_experience = true;
      }

      // TODO: Remove this debug information again
      let input = null;
      if (this.$refs.addressAutocompleteComponent && this.$refs.addressAutocompleteComponent.autocompleteRef) {
        input = this.$refs.addressAutocompleteComponent.autocompleteRef.$refs.input;
      }
      args.debug = {
        disyDown: this.disyDown,
        disyless: this.disyless,
        showManualAddress: this.showManualAddress,
        searchStr: input ? input.value : '(no input field)',
        isValidAddress: this.isValidAddress,
        addressAutocomplete: JSON.stringify(this.addressAutocomplete),
        disylessAddress: JSON.stringify(this.disyless),
      }

      this.isSubmitting = true;
      this.submitError = null;

      try {
        const data = await FormHelpers.postFormData(args);

        const url = data.url || false;
        const disy_down = data.disy_down || false;

        if (data.success) {

          this.submitError = null;

          // Prepare the Analytics event
          const analyticsevent = {
            'event': 'applicationSuccessful',
            'form': 'applicationFormV2',
            'lang': this.formLang,
            'overEighteen': this.isOverEighteen ? 'true' : 'false'
          };

          if (data.gtm_user_data) {
            analyticsevent.user_data = data.gtm_user_data;
          }

          if (data.conzoom || data.conzoomText) {
            analyticsevent.conzoom = data.conzoom;
            analyticsevent.conzoomText = data.conzoomText;
          }

          if (url) {
            //We want the event name to be different when the old pageload is present
            analyticsevent.event = "applicationSuccessful";
            //When the dataLaer.push is done the eventCallback is called.
            //If it is never called, it will force it after 2500 ms.
            analyticsevent.eventCallback = function() {
              window.location.href = url;
            };
            analyticsevent.eventTimeout = 2500;
          }

          // Trigger the analytics event
          if (data.run_tracking && this.mode !== 'manualimport') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(analyticsevent);
          } else if (url) {
            // Redirct to the URL since we're not triggering the Analytics event
            window.location.href = url;
            return;
          }

          if (disy_down) {
            // Show disy down confirmation message
            this.showDisyDownError = true;
            this.hasSubmitted = true;

            // Continue to step 4
            this.switchToStep(this.totalSteps);

            this.isSubmitting = false;
          } else if (!url) {
            // Show the confirmation page (step 4)
            this.showDisyDownError = false;
            this.hasSubmitted = true;
            if (data.loennummer) {
              this.salaryno = data.loennummer;
            }

            if (data.not_logged_in) {
              this.logged_in = false;
            } else {
              this.logged_in = true;

              // Trigger the GTM login event since the user is logged in
              if (data.run_tracking && this.mode !== 'manualimport') {
                const login_analyticsevent = {
                  'event': 'loginSuccesful',
                  'log': 'in', // Some legacy parameter that is still required
                  'type': data.medarbejdertype,
                  'form': this.formName,
                };

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(login_analyticsevent);
              }

              // Switch the Log in button to a Log out button
              if (data.logout_link && data.logout_label) {
                const loginBtn = document.querySelector('header .login a');
                if (loginBtn) {
                  loginBtn.href = data.logout_link;
                  loginBtn.textContent = data.logout_label;
                }
                // Also switch the button in the mobile menu
                const mobileBtn = document.querySelector('#mobile-menu .login a');
                if (mobileBtn) {
                  mobileBtn.href = data.logout_link;
                  mobileBtn.textContent = data.logout_label;
                }
              }
              // Also update the class on the body element
              document.body.classList.add('userLoggedIn');
            }

            // Continue to step 4
            this.switchToStep(this.totalSteps);

            this.isSubmitting = false;
          }

        } else {
          // Handle error response
          const msg = data.message || __('Fejl: Intet svar fra serveren! Prøv venligst igen.');
          this.submitError = msg

          this.isSubmitting = false;
        }

      } catch (error) {
        const msg = __('Fejl: Intet svar fra serveren! Prøv venligst igen.');
        this.submitError = msg

        this.isSubmitting = false;
      }
    },
  }
}
